/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskDocket } from './ExecRiskDocket';
import {
    ExecRiskDocketFromJSON,
    ExecRiskDocketFromJSONTyped,
    ExecRiskDocketToJSON,
} from './ExecRiskDocket';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedDocketScanResponse
 */
export interface ExecRiskPaginatedDocketScanResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedDocketScanResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskDocket>}
     * @memberof ExecRiskPaginatedDocketScanResponse
     */
    results: Array<ExecRiskDocket>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedDocketScanResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedDocketScanResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedDocketScanResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedDocketScanResponse interface.
 */
export function instanceOfExecRiskPaginatedDocketScanResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedDocketScanResponseFromJSON(json: any): ExecRiskPaginatedDocketScanResponse {
    return ExecRiskPaginatedDocketScanResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedDocketScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedDocketScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskDocketFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedDocketScanResponseToJSON(value?: ExecRiskPaginatedDocketScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskDocketToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

